import { useContext } from 'react';
import { AppContext } from '../AppContext.ts';

export function useAppState() {
  const context = useContext(AppContext);

  if (!context) throw new Error('useState must be used within StateProvider');

  return context;
}
